import React from 'react';
import { FileIcon } from 'elements/Icon';

const XLTM = () => (
  <FileIcon>
    <g>
    <rect x="1" y="1" fill="#FFFFFF" width="98" height="138"/>
    <path d="M98,2v136H2V2H98 M100,0H0v140h100V0L100,0z"/>
  </g>
  <g>
    <rect x="12.75" y="24" width="14" height="4"/>
    <rect x="33.083" y="24" width="14" height="4"/>
    <rect x="52.417" y="24" width="14" height="4"/>
    <rect x="72.75" y="24" width="14" height="4"/>
    <rect x="12.75" y="36" width="14" height="4"/>
    <rect x="33.083" y="36" width="14" height="4"/>
    <rect x="52.417" y="36" width="14" height="4"/>
    <rect x="72.75" y="36" width="14" height="4"/>
    <rect x="12.75" y="48" width="14" height="4"/>
    <rect x="33.083" y="48" width="14" height="4"/>
    <rect x="52.417" y="48" width="14" height="4"/>
    <rect x="72.75" y="48" width="14" height="4"/>
    <rect x="12.75" y="60" width="14" height="4"/>
    <rect x="33.083" y="60" width="14" height="4"/>
    <rect x="52.417" y="60" width="14" height="4"/>
    <rect x="72.75" y="60" width="14" height="4"/>
    <rect x="12.75" y="72" width="14" height="4"/>
    <rect x="33.083" y="72" width="14" height="4"/>
    <rect x="52.417" y="72" width="14" height="4"/>
    <rect x="72.75" y="72" width="14" height="4"/>
    <rect x="12.75" y="84" width="14" height="4"/>
    <rect x="33.083" y="84" width="14" height="4"/>
    <rect x="52.417" y="84" width="14" height="4"/>
    <rect x="72.75" y="84" width="14" height="4"/>
  </g>
  <g>
    <rect x="12.701" y="102.621" width="74" height="24"/>
  </g>
  <g>
    <path fill="#FFFFFF" className="text" d="M27.299,118.043h2.367v2.336h-2.367V118.043z"/>
    <path fill="#FFFFFF" className="text" d="M33.803,120.379h-2.797l3.703-5.867l-3.523-5.648h2.875l2.054,3.75l2.11-3.75h2.781l-3.523,5.555
      l3.742,5.961h-2.922l-2.188-3.927L33.803,120.379z"/>
    <path fill="#FFFFFF" className="text" d="M42.635,108.863h2.406v9.445h5.75v2.07h-8.156V108.863z"/>
    <path fill="#FFFFFF" className="text" d="M59.596,108.863v2.039H56.15v9.477h-2.422v-9.477h-3.461v-2.039H59.596z"/>
    <path fill="#FFFFFF" className="text" d="M68.641,108.863h3.463v11.516h-2.242v-7.789c0-0.224,0.003-0.538,0.008-0.941s0.008-0.715,0.008-0.934
      l-2.183,9.664h-2.338l-2.167-9.664c0,0.219,0.003,0.53,0.008,0.934s0.008,0.718,0.008,0.941v7.789h-2.242v-11.516h3.502
      l2.096,9.055L68.641,108.863z"/>
  </g>
  </FileIcon>
);

export default XLTM;



// WEBPACK FOOTER //
// ./src/core/icons/components/files/XLTM.jsx